<template>
  <div class="rank" id="mainContent">
    <!-- 本月线索排行榜（个人） -->
    <div class="rank-box">
      <top title="本月线索排行榜（个人）"></top>
      <div class="rank-box-item">
        <card
          v-for="(item, index) in totalRankList.new_tickets_leaderboard"
          :key="item.appraiser_id"
          class="rank-card">
          <div
            class="rank-card__box"
            :class="{ first: index === 0, second: index === 1, third: index === 2}"
            slot="header">
            <p class='rank-number'>No.{{ index + 1 }}</p>
            <img class="rank-avatar" :src="item.avatar">
          </div>
          <div slot="content" class="rank-card__content">
            <p class="rank-name">{{ item.name }}</p>
            <div class="rank-count">
              <p class="rank-count__clue">线索 {{ item.new_tickets }}</p>
              <p class="rank-count__ownclue">本品线索 {{ item.new_tickets_own }}</p>
            </div>
            <p class="rank-store">{{ item.store }}</p>
          </div>
        </card>
        <x-button
          value="查看详细榜单"
          class="rank-box-item-btn"
          type="primary"
          @click.native="handleDetail(true, 1)"
        >
          查看详细榜单
        </x-button>
      </div>
    </div>
    <!-- 本月评估排行榜（个人） -->
    <div class="rank-box">
      <top title="本月评估排行榜（个人）"></top>
      <div class="rank-box-item">
        <card
          v-for="(item, index) in totalRankList.evaluated_tickets_leaderboard"
          :key="item.appraiser_id"
          class="rank-card">
          <div
            class="rank-card__box"
            :class="{ first: index === 0, second: index === 1, third: index === 2}"
            slot="header">
            <p class='rank-number'>No.{{ index + 1 }}</p>
            <img class="rank-avatar" :src="item.avatar">
          </div>
          <div slot="content" class="rank-card__content">
            <p class="rank-name">{{ item.name }}</p>
            <div class="rank-count">
              <p class="rank-count__clue">评估 {{ item.evaluated_tickets }}</p>
              <p class="rank-count__ownclue">本品评估 {{ item.evaluated_tickets_own }}</p>
            </div>
            <p class="rank-store">{{ item.store }}</p>
          </div>
        </card>
        <x-button
          value="查看详细榜单"
          class="rank-box-item-btn"
          type="primary"
          @click.native="handleDetail(true, 2)"
        >
          查看详细榜单
        </x-button>
      </div>
    </div>
    <!-- 本月FU建线索率排行榜（经销店） -->
    <div class="rank-box">
      <top title="本月FU建线索率排行榜（经销店）"></top>
      <div class="rank-box-item">
        <card
          v-for="(item, index) in totalRankList.fu_created_rate_leaderboard"
          :key="item.appraiser_id"
          class="rank-card">
          <div
            class="rank-card__box"
            :class="{ first: index === 0, second: index === 1, third: index === 2}"
            slot="header">
            <p class='rank-number'>No.{{ index + 1 }}</p>
            <img class="rank-avatar" :src="item.avatar">
          </div>
          <div slot="content" class="rank-card__content">
            <p class="rank-name">{{ item.name }}</p>
            <p class="rank-rate">FU建线索率 {{ item.fu_created_rate | toPercent }}</p>
          </div>
        </card>
        <x-button
          value="查看详细榜单"
          class="rank-box-item-btn"
          type="primary"
          @click.native="handleDetail(false, 1)"
        >
          查看详细榜单
        </x-button>
      </div>
    </div>
    <!-- 本月FU评估率排行榜（经销店） -->
    <div class="rank-box">
      <top title="本月FU评估率排行榜（经销店）"></top>
      <div class="rank-box-item">
        <card
          v-for="(item, index) in totalRankList.fu_evaluated_rate_leaderboard"
          :key="item.appraiser_id"
          class="rank-card">
          <div
            class="rank-card__box"
            :class="{ first: index === 0, second: index === 1, third: index === 2}"
            slot="header">
            <p class='rank-number'>No.{{ index + 1 }}</p>
            <img class="rank-avatar" :src="item.avatar">
          </div>
          <div slot="content" class="rank-card__content">
            <p class="rank-name">{{ item.name }}</p>
            <p class="rank-rate">FU评估率 {{ item.fu_evaluated_rate | toPercent }}</p>
          </div>
        </card>
        <x-button
          value="查看详细榜单"
          class="rank-box-item-btn"
          type="primary"
          @click.native="handleDetail(false, 2)"
        >
          查看详细榜单
        </x-button>
      </div>
    </div>
    <foot :desc="desc"></foot>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { XButton, Card } from '@lx-frontend/cvux'
import Top from './components/Top'
import Foot from './components/Footer'
export default {
  components: { Top, Foot, Card, XButton },
  name: 'rankList',
  data() {
    return {
      price: '',
      desc: '',
      offsetTop: 0,
      timer: null
    }
  },
  activated() {
    if (this.offsetTop > 0) {
      this.timer = setTimeout(() => {
        window.scrollTo(0, this.offsetTop)
      })
    }
  },
  deactivated() {
    this.offsetTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
    window.clearTimeout(this.timer)
  },
  async created() {
    await this.getTotalRankList()
    this.desc = `数据截止：${this.totalRankList.date}`
  },
  methods: {
    handleDetail(bool, type) {
      const path = bool ? 'personalRank' : 'storeRank'
      this.$router.push({
        path: `/usedcar/${path}`,
        query: {
          type: type
        }
      })
    },
    ...mapActions('rank', ['getTotalRankList'])
  },
  computed: {
    ...mapState('rank', ['totalRankList'])
  },
  filters: {
    toPercent(num) {
      return num !== null ? Math.round(num * 100) + '%' : '--'
    }
  }
}

</script>
<style lang="less" scoped>
@import "../../../stylesheets/base/fn.less";
.rank {
  background: #889aae;
  padding-bottom: 28/@w;
  height: auto;

  &-box{
    width: 356/@w;
    margin: 14/@w auto;

    &-item{
      width: 340/@w;
      margin: auto;
      background: #fff;
      padding: 15/@w;
      box-sizing: border-box;

      .rank-card{
        display: flex;
        flex: row nowrap;
        padding: 14/@w 0;
        border-bottom: 1px solid #f8f8f8;

        &:before{
          border: none;
        }

        &:after{
          border: none;
        }

        &__box{
          position: relative;
          margin-left: 26/@w;

          .rank-number{
            position: absolute;
            top: 46/@w;
            display: block;
            width: 100%;
            height: 15/@w;
            line-height: 15/@w;
            text-align: center;
            font-family: PingFangSC-Semibold;
            font-size: 12/@w;
            color: #ffffff;
            z-index: 2;
          }

          .rank-avatar{
            display: block;
            width: 60/@w;
            height: 60/@w;
            border-radius: 50%;
          }

          &:before{
            position: absolute;
            display: block;
            top: -12/@w;
            right: -5/@w;
            content: "";
            width: 25/@w;
            height: 22/@w;
          }

          &:after{
            position: absolute;
            display: block;
            top: 42/@w;
            right: -10/@w;
            content: "";
            width: 76/@w;
            height: 18/@w;
          }

        }

        .first{

          &:before{
            background: url('../../../stylesheets/images/rank/first-top.png') no-repeat 0 0 / cover;
          }

          &:after{
            background: url('../../../stylesheets/images/rank/first-bottom.png') no-repeat 0 0 / cover;
          }

        }

        .second{

          &:before{
            background: url('../../../stylesheets/images/rank/second-top.png') no-repeat 0 0 / cover;
          }

          &:after{
            background: url('../../../stylesheets/images/rank/second-bottom.png') no-repeat 0 0 / cover;
          }

        }

        .third{

          &:before{
            background: url('../../../stylesheets/images/rank/third-top.png') no-repeat 0 0 / cover;
          }

          &:after{
            background: url('../../../stylesheets/images/rank/third-bottom.png') no-repeat 0 0 / cover;
          }

        }

        &__content{
          width: 200/@w;
          margin-left: 27/@w;

          .rank-name{
            font-family: PingFangSC-Semibold;
            font-size: 16/@w;
            color: #333333;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
          }

          .rank-count{
            font-size: 13/@w;
            display: flex;
            flex: row nowrap;
            width: 200/@w;
            height: 30/@w;
            line-height: 30/@w;

            &__clue, &__evaluate{
              width: 80/@w;
              color: #09b6f8;
            }

            &__ownclue, &__ownevaluate{
              color: #333333;
            }
          }

          .rank-store{
            font-family: PingFangSC-Regular;
            font-size: 13/@w;
            color: #999999;
            overflow:hidden;
            text-overflow:ellipsis;
            white-space:nowrap;
          }

          .rank-rate{
            height: 30/@w;
            line-height: 30/@w;
            font-size: 13/@w;
            color: #09b6f8;
          }
        }
      }

      &-btn{
        width: 140/@w;
        height: 36/@w;
        margin: 17/@w auto;
        border-radius: 18/@w;
        border: solid 1px #889aae;
        font-family: PingFangSC-Regular;
        font-size: 15/@w;
        color: #889aae;
        background: #fff;

        &:active{
          color: #fff;
          background: #889aae;
        }
      }
    }
  }
}
</style>
